// extracted by mini-css-extract-plugin
export default {"outcomeCard":"OutcomeCard_outcomeCard__PBAT7"};